import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Trash2 } from 'lucide-react'

interface DeleteConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  title: string
  description?: string
  itemName?: string
}

const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  itemName,
}: DeleteConfirmDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="w-[95%] max-w-[400px] rounded-2xl p-6 gap-6 bg-white!">
        <AlertDialogHeader className="space-y-3">
          <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-1">
            <Trash2 className="w-6 h-6 text-red-500" />
          </div>
          <AlertDialogTitle
            className="text-center text-xl text-gray-900"
            style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 700 }}
          >
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription
            className="text-center text-gray-500 text-sm"
            style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400 }}
          >
            {description ||
              'Are you sure you want to delete this item? This action cannot be undone.'}
            {itemName && (
              <span className="block mt-2 font-medium text-gray-900 bg-gray-50 py-2 px-3 rounded-lg border border-gray-100">
                "{itemName}"
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="grid grid-cols-2 gap-3 sm:space-x-0">
          <AlertDialogCancel
            className="w-full mt-0 h-10 rounded-xl border-gray-200 text-gray-700 font-semibold hover:bg-gray-50 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
              onOpenChange(false)
            }}
            className="w-full h-10 rounded-xl bg-red-500 text-white font-semibold hover:bg-red-600 transition-colors border-0"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteConfirmDialog
